import { FiX } from 'react-icons/fi';

const DataLayersDrawer = ({ isOpen, onClose, groups = [] }) => (
  <>
    <div
      className={`fixed inset-0 z-50 bg-black/30 transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
      onClick={onClose}
      aria-hidden="true"
    />
    <aside
      className={`fixed inset-y-0 right-0 z-50 w-full max-w-md bg-white shadow-2xl border-l border-gray-200 transform transition-transform duration-300 flex flex-col ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
      role="dialog"
      aria-label="Data Layers"
      aria-modal="true"
    >
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <div>
          <h3 className="text-lg font-semibold text-gray-800">Data Layers</h3>
          <p className="text-sm text-gray-500">Toggle supplemental map overlays by category.</p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="p-2 text-gray-500 hover:text-gray-800 rounded-full hover:bg-gray-100"
          aria-label="Close data layers"
        >
          <FiX className="w-5 h-5" />
        </button>
      </div>
      <div className="flex-1 px-6 py-4 overflow-y-auto space-y-6">
        {groups.map((group) => (
          <div key={group.title}>
            <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">{group.title}</h4>
            <div className="space-y-3">
              {group.items.map((item) => (
                <div
                  key={item.id}
                  className="p-3 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50/30 transition"
                >
                  <label className="flex items-start gap-3">
                    <input
                      type="checkbox"
                      checked={item.checked}
                      onChange={() => item.onChange(!item.checked)}
                      className="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded"
                    />
                    <div className="flex items-start gap-3 flex-1">
                      {item.icon ? (
                        <span className={`mt-0.5 ${item.iconClass || 'text-blue-600'} shrink-0`}>
                          <item.icon className="w-5 h-5" aria-hidden="true" />
                        </span>
                      ) : null}
                      <div>
                        <div className="text-sm font-medium text-gray-800">{item.label}</div>
                        {item.description ? (
                          <div className="text-xs text-gray-500 mt-0.5">{item.description}</div>
                        ) : null}
                      </div>
                    </div>
                  </label>
                  {Array.isArray(item.children) && item.children.length > 0 ? (
                    <div className={`mt-3 ml-7 space-y-2 ${item.checked ? '' : 'opacity-50 pointer-events-none'}`}>
                      {item.children.map((child) => (
                        <label key={child.id} className="flex items-center gap-2 text-sm text-gray-700">
                          <input
                            type="checkbox"
                            checked={child.checked}
                            onChange={() => child.onChange(!child.checked)}
                            disabled={!item.checked}
                            className="h-3.5 w-3.5 text-blue-600 border-gray-300 rounded"
                          />
                          <span>{child.label}</span>
                        </label>
                      ))}
                    </div>
                  ) : null}
                  {item.numericFilter ? (
                    <div className="mt-3 ml-7">
                      <div className="flex items-center justify-between mb-1">
                        <label className="block text-xs font-medium text-gray-600">
                          {item.numericFilter.label}
                        </label>
                        <span className="text-xs font-semibold text-blue-700">
                          {item.numericFilter.value}
                        </span>
                      </div>
                      <input
                        type="range"
                        min={item.numericFilter.min ?? 0}
                        max={item.numericFilter.max ?? 100}
                        step={item.numericFilter.step ?? 1}
                        value={item.numericFilter.value}
                        onChange={(e) => item.numericFilter.onChange(e.target.value)}
                        className="w-56 accent-blue-600"
                      />
                      <div className="text-[11px] text-gray-500 mt-1">
                        Show tracts where percentile is above this value.
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </aside>
  </>
);

export default DataLayersDrawer;
